import { produce as applyImmutably } from 'immer';
import { AsyncStatus } from 'lib-shared-legacy-types';
import { Organization } from 'lib-shared-types-api';
import { Action, handleActions } from 'redux-actions';
import { DeepReadonly } from 'ts-essentials';

import { websocketActions } from '../../../../app/middleware/websocket/actions/websocket';
import { organizationActions } from '../actions/organization';

const {
  organizationV2Get,
  organizationV2GetSucceeded,
  organizationV2GetFailed,

  organizationV2GetPresignedAvatarUrl,
  organizationV2GetPresignedAvatarUrlSucceeded,
  organizationV2GetPresignedAvatarUrlFailed,

  organizationV2UploadAvatar,
  organizationV2UploadAvatarSucceeded,
  organizationV2UploadAvatarFailed,

  organizationV2Edit,
  organizationV2EditSucceeded,
  organizationV2EditFailed,
} = organizationActions;

export type OrganizationStateT = {
  meta: {
    asyncStatus: AsyncStatus;
  };
  organization: Organization;
};

type State = DeepReadonly<OrganizationStateT>;

const initialState: State = {
  meta: {
    asyncStatus: 'succeeded',
  },
  organization: {
    name: '',
    avatar_url: '',
    id: '',
    created_at: '',
    trial_ended_at: 'null',
    subdomain: '',
    suspended: false,
    default_queue: '',
    default_outbound_number: '',
    default_hold_music_id: '',
    timezone: null,
  },
};

// Reducer
export const organization = handleActions(
  {
    [websocketActions.createFulfilled.type]: (state, action: any) => {
      return applyImmutably(state, (draftState) => {
        draftState.organization = action.payload.params.organization;
      });
    },

    [organizationV2Get.toString()]: (state: State) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'loading';
      });
    },

    [organizationV2GetSucceeded.toString()]: (state: State, action) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'succeeded';
        draftState.organization = action.payload.organization;
      });
    },

    [organizationV2GetFailed.toString()]: (state: State) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'failed';
      });
    },

    [organizationV2GetPresignedAvatarUrl.toString()]: (state: State) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'loading';
      });
    },

    [organizationV2GetPresignedAvatarUrlSucceeded.toString()]: (
      state: State,
    ) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'succeeded';
      });
    },

    [organizationV2GetPresignedAvatarUrlFailed.toString()]: (state: State) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'failed';
      });
    },

    [organizationV2UploadAvatar.toString()]: (state: State) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'loading';
      });
    },

    [organizationV2UploadAvatarSucceeded.toString()]: (
      state: State,
      action: Action<any>,
    ) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'succeeded';
        draftState.organization.avatar_url = action.payload.updates.avatar_url;
      });
    },

    [organizationV2UploadAvatarFailed.toString()]: (state: State) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'failed';
      });
    },

    [organizationV2Edit.toString()]: (state: State) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'loading';
      });
    },

    [organizationV2EditSucceeded.toString()]: (
      state: State,
      action: Action<any>,
    ) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'succeeded';
        draftState.organization = action.payload;
      });
    },

    [organizationV2EditFailed.toString()]: (state: State) => {
      return applyImmutably(state, (draftState) => {
        draftState.meta.asyncStatus = 'failed';
      });
    },
  },
  initialState,
);
